import Column from '@app/components/layout/Column'
import { DataCard } from './DataCard'
import { useMemo } from 'react'
import { ViewEventModel } from 'functions/app/event/view'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { PageMediaGallery } from '@app/components/blocks/mediaGallery/PageMediaGallery'
import { useTranslations } from '@i18n/useLanguage'
import { Title } from '@app/components/core/typography/Title'
import { ItemListCardItem } from '@app/components/blocks/card/ItemListCard'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'

export const RightColumn = ({ event }: { event: ViewEventModel }) => {
  const [_, navigate] = useLocation()
  const eventImages = useMemo(() => event?.images ?? [], [event?.images])
  const t = useTranslations().app.eventPage

  const organiser =
    event.initiative?.title && event.initiative?.slug
      ? {
          title: event.initiative.title,
          image: event.initiative.images?.[0]?.src,
          onClick: () => {
            navigate(pages.initiative(event.initiative.slug))
          },
        }
      : undefined

  return (
    <Column
      gap="2.5rem"
      alignItems="stretch"
      style={{ flex: '1 1 23rem', minWidth: '23rem' }}
    >
      <PageMediaGallery
        title={event.title}
        images={eventImages}
        defaultImage={defaultProjectPicture}
        style={{ width: '100%' }}
      />
      <DataCard event={event} />

      {organiser && (
        <Column>
          <Title.H4 style={{ marginBottom: 0 }}>{t.organisers}</Title.H4>
          <ItemListCardItem item={organiser} />
        </Column>
      )}
    </Column>
  )
}
